function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nigeria-Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M326.68,894.22q19.24,0,28.12,8.15t8.89,25.35v61.46H344.45V930.32q0-19.44-21.8-19.44a33.1,33.1,0,0,0-17.77,5,47.79,47.79,0,0,1,1.29,11.84v61.46H286.93V930.32q0-19.44-21.8-19.44a55.61,55.61,0,0,0-19.42,3.52v74.78H226.48V903.85a84.77,84.77,0,0,1,20.06-7,102.71,102.71,0,0,1,22.62-2.68q18,0,26.75,7A71.16,71.16,0,0,1,326.68,894.22ZM429.61,992q-22,0-33.07-12.59t-11.08-36.65q0-48.69,44-48.68,22.17,0,33.34,12.49t11.18,36.19q0,23.68-11.54,36.46T429.61,992Zm-.19-16.48q25.29,0,25.28-32.76,0-16.29-6-24.34t-19.24-8.06q-13.37,0-19.14,8.24t-5.77,24.16q0,15.91,5.95,24.34T429.42,975.48Zm108.79-81.26q20.52,0,31.14,12.4T580,941.79q0,27.4-12.73,38.78T534.91,992q-39.39,0-39.39-21.1V859.05h19.06V900a57.17,57.17,0,0,1,12-4.17A51.75,51.75,0,0,1,538.21,894.22Zm-4.77,80.89q15,0,21-8.7t6-23.88q0-15.54-6.32-23.69t-18.77-8.14a44.67,44.67,0,0,0-10.72,1.38,37.65,37.65,0,0,0-10,4v50Q514.58,975.12,533.44,975.11Zm68.3-111.25h20.52v17.59H601.74Zm.55,32.95h19.24l.18,92.37H602.29Zm46.5,92.37V861.09h19.06V989.18ZM732.3,894q21.44,0,31.42,14t9.8,39.15H709q.93,13.7,8,20.83t20.06,7.12a61.57,61.57,0,0,0,29.68-7.59v18.14Q752.45,992,734,992q-20.7,0-32.52-12.68t-11.81-36q0-23.88,11.17-36.55T732.3,894ZM731.75,910q-9.71,0-15.2,5.19t-7.15,17.58h44.52q-1.29-11.85-6.6-17.3T731.75,910ZM548,148.46q-31.83-7.87-49-7.88c-85.39,0-154.62,69-154.62,154.09S413.64,448.77,499,448.77s154.63-69,154.63-154.1a154.18,154.18,0,0,0-4.46-36.89l122.93-33.11a279.1,279.1,0,0,1-36.65,224.24L531.89,826.3H343.31l134-247c.73-1.36-1.42-4.36-3.22-4.52-143.19-13-255.35-133-255.35-279.09,0-154.79,125.9-280.26,281.22-280.26a281.81,281.81,0,0,1,83.86,12.67Z",
    style: {
      fill: "#006e53",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 498.07,
    cy: 294.67,
    r: 84.75,
    style: {
      fill: "#d6e806"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.46,236.89a153.65,153.65,0,0,0-79-82.83M698.4,213.77A218.49,218.49,0,0,0,588.61,98.2m161.8,98.24A273.23,273.23,0,0,0,605.94,46.2",
    style: {
      fill: "none",
      stroke: "#d6e806",
      strokeLinecap: "round",
      strokeWidth: "19.2619642679972px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNineMobile);
export default __webpack_public_path__ + "static/media/nine_mobile.052f9328241e19f8f7743d82ef6afbb8.svg";
export { ForwardRef as ReactComponent };